import WeatherContainer from "./components/WeatherContainer/WeatherContainer";
function App() {
  return (
    <div className="container">
      <WeatherContainer />
    </div>
  );
}

export default App;
